import React from "react";
import { useNavigate } from "react-router-dom";

const NoPermission = () => {
  const navigate = useNavigate();

  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: "80vh" }}>
      <div className="card custom-card text-center w-100" style={{ minHeight: "80vh" }}>
        <div className="card-body d-flex flex-column align-items-center justify-content-center">

          <div className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle bg-light"
            style={{ width: "110px", height: "110px" }}>
            <i className="fa fa-lock text-primary" style={{ fontSize: "48px" }}></i>
          </div>

          <h1 className="text-primary fw-bold mb-1" style={{ fontSize: "90px" }}>403</h1>

          <h4 className="fw-bold text-dark mb-3">Access Denied</h4>

          <p className="text-muted mb-0 fs-6">
            You don't have permission to access this page.
            <br />
            Please contact your administrator.
          </p>

        </div>
      </div>
    </div>
  );
};

export default NoPermission;